module.exports = "https://static-production.npmjs.com/a39ceb9e9ad640f4de8eee094063d890.png";